// firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAkV66gdSFqsmsBYHWYdOIWaUpJpyOi0-0",
    authDomain: "suprith-hattikal.firebaseapp.com",
    projectId: "suprith-hattikal",
    storageBucket: "suprith-hattikal.appspot.com",
    messagingSenderId: "875405824331",
    appId: "1:875405824331:web:df9f968dcfe022d9f558ce",
    measurementId: "G-C46G0JMKYH"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };